import { useCallback, useState } from "react";

export const useToggle = (
    initial: boolean,
): [boolean, { toggle: () => void; on: () => void; off: () => void }] => {
    const [value, setValue] = useState(initial);
    const toggle = useCallback(() => setValue(it => !it), [setValue]);
    const on = useCallback(() => setValue(true), [setValue]);
    const off = useCallback(() => setValue(false), [setValue]);
    return [value, { toggle, on, off }];
};
